import {
  CommonMFE,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import React from "react";

type TImageWrapperProps = {
  id: string;
  __host__: CommonMFE.Types.THost;
  isEditMode: boolean;
  image: any;
};

/** Image Core Component */
export const ImageWrapper = (props: TImageWrapperProps) => {
  const { id: containerID, __host__, isEditMode, image } = props;

  return (
    <ReactMFE.Remote
      id={CommonMFE.generateID(
        containerID,
        `${MFE_NAMES.tpdVisoreNoCarosello}-Immagine`
      )}
      __deps__={React}
      __host__={__host__}
      __mfeName__={MFE_NAMES.tpdImage}
      isEditMode={isEditMode}
      {...image}
    />
  );
};
